import {
  getSessionId
} from "./chunk-FZO3U2FN.mjs";
import {
  Completion
} from "./chunk-LNWWNP75.mjs";
import {
  sendEvents,
  sendEventsViaBeacon
} from "./chunk-56HYCTGH.mjs";

// src/events/track-nonidle-activity/track-nonidle-activity.ts
var trackNonIdleActivity = () => {
  let timeOfActivityStart = performance.now();
  let timeEngaged = 0;
  let idleTime = 0;
  let isIdle = true;
  let idleTimer;
  let reportTimer;
  const idleTimeout = 5e3;
  let reportTimeout = 5e3;
  const maxNonIdleReportTimeout = 6e4;
  const maxIdleReportTimeout = 3e5;
  const setIdle = () => {
    getSessionId({ updateContext: true });
    idleTime = performance.now();
    timeEngaged += idleTime - timeOfActivityStart;
    isIdle = true;
  };
  const reportActivity = async ({ beacon } = {}) => {
    if (window.yvaDatastore?.config.debug) {
      console.log(`Reporting ${isIdle ? "idle" : "non-idle"} activity at`, reportTimeout);
    }
    if (!isIdle) {
      timeEngaged += performance.now() - timeOfActivityStart;
    }
    if (timeEngaged > 0) {
      Completion.fire(
        {
          completionContext: "non_idle_segment",
          contentType: "non_idle_segment",
          durationMillis: timeEngaged,
          success: true
        },
        // Sometimes completion event isn't in the datastore with the sends happen below, so we'll also send it when complete here.
        { callback: beacon ? sendEventsViaBeacon : sendEvents }
      );
    }
    if (beacon) {
      sendEventsViaBeacon();
    } else {
      sendEvents();
    }
    timeEngaged = 0;
    timeOfActivityStart = performance.now();
    reportTimeout = getNextReportingTimeout(reportTimeout);
    reportTimer = window.setTimeout(() => {
      void (async () => {
        await reportActivity();
      })();
    }, reportTimeout);
  };
  const keepAlive = () => {
    if (isIdle) {
      isIdle = false;
      timeOfActivityStart = performance.now();
      getSessionId({ updateContext: true });
    }
    window.clearTimeout(idleTimer);
    idleTimer = window.setTimeout(setIdle, idleTimeout);
  };
  const getNextReportingTimeout = (lastReportTimeout) => {
    const nextReportingTimeout = Math.min(
      lastReportTimeout * 2,
      isIdle ? maxIdleReportTimeout : maxNonIdleReportTimeout
    );
    if (window.yvaDatastore?.config.debug) {
      console.log("Next reporting timeout", nextReportingTimeout);
    }
    return nextReportingTimeout;
  };
  const windowEvents = ["load", "scroll", "resize", "focus"];
  const bodyEvents = ["mousedown", "mousemove", "keydown"];
  windowEvents.forEach((event) => {
    window.addEventListener(event, keepAlive);
  });
  bodyEvents.forEach((event) => {
    document.body.addEventListener(event, keepAlive);
  });
  window.addEventListener("blur", setIdle);
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      void (async () => {
        await reportActivity({ beacon: true });
      })();
    }
  });
  window.addEventListener("beforeunload", () => {
    void (async () => {
      await reportActivity({ beacon: true });
    })();
  });
  idleTimer = window.setTimeout(setIdle, idleTimeout);
  reportTimer = window.setTimeout(() => {
    void (async () => {
      await reportActivity();
    })();
  }, reportTimeout);
  return function clearTracking() {
    clearTimeout(idleTimer);
    clearTimeout(reportTimer);
  };
};

export {
  trackNonIdleActivity
};
